import { CR_SUBMISSION } from '../constants';

export type SubmitButtonStateParams = {
    rootElement: Pick<HTMLElement, 'querySelector'>;
    disabled: boolean;
    loading: boolean;
};
export const setSubmitButtonState = (params: SubmitButtonStateParams) => {
    const submitButtonElement = params.rootElement.querySelector<HTMLOcButtonV1Element>(CR_SUBMISSION.SUBMIT.BUTTON_SELECTOR);

    if (submitButtonElement === null) return;

    submitButtonElement.disabled = params.disabled;
    submitButtonElement.loading = params.loading;
};
